import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function M4Icon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      enableBackground="new 0 0 30 30"
      titleAccess="M4">
      <path
        d="M3.8 5.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V8.6c0-1.7 1.4-3 3-3z"
        fill="#0a4842"
      />
      <path
        d="M3.8 5.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V8.6c0-1.7 1.4-3 3-3z"
        fill="none"
        stroke="#f2b460"
        strokeWidth={1.5}
      />
      <path
        d="M8.8 19.6c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-6.2c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2h.6c.2 0 .3 0 .5.1.1.1.2.2.3.4l1.5 3.8 1.6-3.8c.1-.2.2-.3.3-.4.1-.1.3-.1.5-.1h.6c.2 0 .3.1.4.2.1.1.2.2.2.4V19c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.5c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-3.9l-1 2.3c-.1.2-.2.3-.3.4-.1.1-.3.1-.5.1h-.3c-.2 0-.3 0-.5-.1-.1-.1-.2-.2-.3-.4l-1-2.3V19c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.3zm8.8-2.8c0 .1 0 .1 0 0h1.7c.1 0 .1 0 .1-.1v-2.4l-1.8 2.5zm-.9 1.4c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-.2c0-.4.1-.7.3-1l2.6-3.6c.2-.3.5-.5.9-.5h.5c.2 0 .3.1.4.2.1.1.2.2.2.4v3.9c0 .1 0 .1.1.1h.4c.2 0 .3.1.4.2.1.1.2.2.2.4v.2c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.4c-.1 0-.1 0-.1.1v.6c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.5c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-.7c0-.1 0-.1-.1-.1h-2.5z"
        fill="#f2b460"
      />
    </SvgIcon>
  );
}
